import { Box, Container, Typography, Stack, Divider } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import PageHero from '../components/common/PageHero';
import AnimatedSection from '../components/common/AnimatedSection';
import { useLegal } from '../hooks/usePublicApi';
import { datenschutz as staticData } from '../data/legal';

export default function Datenschutz() {
  const { legal: apiData } = useLegal('datenschutz');
  const datenschutz = apiData || staticData;

  return (
    <>
      <Helmet>
        <title>Datenschutzerklärung — Süd Ausbau GmbH</title>
      </Helmet>

      <PageHero title="Datenschutzerklärung" />

      <Box sx={{ py: { xs: 6, md: 10 } }}>
        <Container maxWidth="md">
          <AnimatedSection>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
              {datenschutz.intro}
            </Typography>
            <Stack spacing={4}>
              {(datenschutz.sections || []).map((section, i) => (
                <Box key={i}>
                  <Typography variant="h5" sx={{ mb: 2 }}>
                    {section.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary" sx={{ whiteSpace: 'pre-line' }}>
                    {section.content}
                  </Typography>
                  {i < (datenschutz.sections || []).length - 1 && <Divider sx={{ mt: 4 }} />}
                </Box>
              ))}
            </Stack>
          </AnimatedSection>
        </Container>
      </Box>
    </>
  );
}
